import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from './AppLayout';
import { buttonStyle, cardTitle, inputStyle, labelStyle, subtitle } from './quoteStyles';

const ConsultantLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async event => {
    event.preventDefault();

    const response = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ username, password, role: 'consultant' }),
    });

    const data = await response.json();
    if (!response.ok || !data.token) {
      alert(data.error || 'Login failed');
      return;
    }

    navigate('/consultant/dashboard');
  };

  return (
    <AppLayout>
      <div style={styles.box}>
        <h1 style={cardTitle}>Consultant Login</h1>
        <p style={subtitle}>Review applications and send personalized quote emails.</p>

        <form onSubmit={handleLogin}>
          <div style={styles.row}>
            <label style={labelStyle}>Username</label>
            <input
              type="text"
              required
              value={username}
              onChange={event => setUsername(event.target.value)}
              style={inputStyle}
            />
          </div>

          <div style={styles.row}>
            <label style={labelStyle}>Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={event => setPassword(event.target.value)}
              style={inputStyle}
            />
          </div>

          <button type="submit" style={{ ...buttonStyle, width: '100%' }}>
            Login
          </button>
        </form>

        <div style={styles.demo}>
          Demo user: <b>consultant</b> / <b>consultant1234!</b>
        </div>
      </div>
    </AppLayout>
  );
};

const styles = {
  box: {
    background: '#f7fcf8',
    border: '1px solid #d8e9df',
    borderRadius: 12,
    margin: '22px auto',
    maxWidth: 440,
    padding: 26,
  },
  row: {
    marginBottom: 14,
  },
  demo: {
    color: '#5a7261',
    fontSize: 14,
    lineHeight: 1.6,
    marginTop: 16,
  },
};

export default ConsultantLogin;
